<template>
  <section
    v-show="isReady"
    :id="anchor"
    v-editable="blok"
    :class="sectionClass"
    class="block block-tool block-tool-service-providers"
  >
    <div class="container container--without-padding">
      <div class="card">
        <div class="card__inner">
          <ClientOnly>
            <MediaCardImage
              :max-width="720"
              :media="audienceImage"
              class="media--card hidden-xs"
            />
          </ClientOnly>
          <div class="card__content">
            <slot />
            <h2 class="h2">Find a Service Provider</h2>
            <div class="flex flex-col">
              <div class="filter__wrapper">
                <FilterByAudiences
                  v-model="filters['audiences']"
                  :show-selections="true"
                  label="For"
                  placeholder="All Audiences"
                />
              </div>
              <div class="filter__wrapper">
                <FilterByServiceType
                  v-model="filters['serviceType']"
                  :show-selections="true"
                  label="To help with"
                  placeholder="Any type of support"
                />
              </div>
              <div class="filter__wrapper">
                <FilterByStates
                  v-model="filters['states']"
                  :show-selections="true"
                  label="In"
                  placeholder="Any State or Territory"
                />
              </div>
              <button
                :disabled="isBusy"
                class="tool__submit button button--success button--xl"
                @click="submit"
              >
                <span>
                  {{ cta }}
                </span>
                <i class="icon icon--lg">
                  <Icon name="fa6-solid:arrow-right" />
                </i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { BlockToolServiceProvidersStoryblok } from '~/types/storyblok'

const props = withDefaults(
  defineProps<{
    blok: BlockToolServiceProvidersStoryblok
    cta?: string
  }>(),
  {
    cta: 'Find Services',
  },
)
const filters = ref({
  states: [],
  serviceType: [],
  audiences: [],
})
const selectedAudiences = ref<string[]>([])
const { sectionClass } = useStoryContent(toRefs(props))
const { audienceImage, isBusy } = await useTool({
  ...toRefs(props),
  filters,
  selectedAudiences,
})
const router = useRouter()
const isReady = computed(() => !!audienceImage.value?.filename)
const anchor = computed(() => props.blok?.anchor)
function submit() {
  isBusy.value = true

  const states = filters.value?.states?.length
    ? filters.value?.states?.join(',')
    : undefined
  const serviceType = filters.value?.serviceType?.length
    ? filters.value?.serviceType?.join(',')
    : undefined
  const audiences = filters.value?.audiences?.length
    ? filters.value?.audiences?.join(',')
    : undefined

  router.push({
    path: '/service-providers',
    query: {
      states,
      'service-type': serviceType,
      audiences,
    },
  })
}
</script>

<style lang="less">
.block-tool {
  button.reset .icon {
    line-height: inherit;
  }
}
</style>
